"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef } from "react";
import BrainLeftSidebarWaves from "../left-sidebar/waves/BrainLeftSidebarWaves";
import MemesWaveFooter from "../left-sidebar/waves/MemesWaveFooter";
import { useLayout } from "../my-stream/layout/LayoutContext";
interface BrainMobileWavesProps {
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
}
const BrainMobileWaves: React.FC<BrainMobileWavesProps> = t0 => {
  const $ = _c(7);
  const {
    onOpenQuickVote,
    onPrefetchQuickVote
  } = t0;
  const {
    mobileWavesViewStyle
  } = useLayout();
  const scrollContainerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300 tw-space-y-4 tw-px-2 sm:tw-px-4 md:tw-px-6 tw-pt-2" ref={scrollContainerRef}><BrainLeftSidebarWaves scrollContainerRef={scrollContainerRef} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onOpenQuickVote || $[2] !== onPrefetchQuickVote) {
    t2 = <MemesWaveFooter onOpenQuickVote={onOpenQuickVote} onPrefetchQuickVote={onPrefetchQuickVote} />;
    $[1] = onOpenQuickVote;
    $[2] = onPrefetchQuickVote;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== mobileWavesViewStyle || $[5] !== t2) {
    t3 = <div className="tw-flex tw-h-full tw-min-h-0 tw-flex-col" style={mobileWavesViewStyle}>{t1}{t2}</div>;
    $[4] = mobileWavesViewStyle;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default BrainMobileWaves;